module.exports = __webpack_public_path__ + "img/hassel-free.6554787c.png";